var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMicrosoft = function SvgMicrosoft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F35325",
    d: "M11.246 7.461H0v11.247h11.246V7.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#81BC06",
    d: "M23.703 7.461H12.457v11.247h11.246V7.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#05A6F0",
    d: "M11.246 19.919H0v11.246h11.246V19.92Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA08",
    d: "M23.703 19.919H12.457v11.246h11.246V19.92Z"
  })));
};
export default SvgMicrosoft;